import {route} from './../../../routes/web'
import {setMessage} from './../../../actions/setMessage'
import {request} from './../../../functions/request'
import {ParseError} from './../../../functions/error-parse'

export const shop_types_request_invalid = 'shop_types_request_invalid';
export const shop_types_request_send = 'shop_types_request_send';
export const shop_types_request_valid = 'shop_types_request_valid';

export function ShopTypesRequestInvalid() {
    return {
        type: shop_types_request_invalid
    }
}

export function ShopTypesRequestSend() {
    return {
        type: shop_types_request_send,
    }
}

export function ShopTypesRequestValid(data) {
    return {
        type: shop_types_request_valid,
        data
    }
}

export function fetchShopTypes(id) {
    return function (dispatch) {
        dispatch(ShopTypesRequestSend());
        request(route.shop.types, {
                point: id
            },
            (data) => {
                if (data.success && data.data_response.success) {
                    dispatch(ShopTypesRequestValid(data.data_response));
                } else {
                    if (data.msg || data.data_response.msg) {
                        dispatch(setMessage(ParseError(data.msg || data.data_response.msg), 'error'));
                    } else {
                        dispatch(setMessage('Неверные данные', 'error'));
                    }
                    dispatch(ShopTypesRequestInvalid());
                }
            },
            (error) => {
                dispatch(ShopTypesRequestInvalid());
            });
    }
}